import { Link } from "react-router-dom";

const defaultMessage =
  "SalonBusinessCPA is available for active Ellyanna Booking subscribers with an active SalonBusinessCPA trial or paid accounting package.";

const paymentMessage =
  "Your SalonBusinessCPA trial has ended. Choose an accounting package to continue using SalonBusinessCPA. Your Ellyanna Booking account is still separate.";

export default function SalonBusinessCpaAccessRequired({ access }) {
  const reason = access?.reason || "";
  const needsAccountingPackage = reason === "salonbusinesscpa_package_required";
  return (
    <main className="min-h-screen bg-[#f8f6f4] px-5 py-10 text-slate-950">
      <section className="mx-auto max-w-3xl rounded-3xl border border-slate-200 bg-white p-6 text-center shadow-sm md:p-10">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-500">
          Ellyanna SalonBusinessCPA
        </p>
        <h1 className="mt-4 text-3xl font-semibold text-slate-950">
          {needsAccountingPackage ? "Accounting package needed" : "Subscription needed"}
        </h1>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-6 text-slate-600">
          {needsAccountingPackage ? paymentMessage : defaultMessage}
        </p>
        {reason ? (
          <p className="mx-auto mt-3 max-w-xl text-xs leading-5 text-slate-500">
            Current status: {reason.replaceAll("_", " ")}
          </p>
        ) : null}
        <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/manager/manage/billing"
            className="inline-flex min-h-11 items-center justify-center rounded-full bg-rose-500 px-5 text-sm font-semibold text-white hover:bg-rose-600"
          >
            Open Billing
          </Link>
          <Link
            to="/"
            className="inline-flex min-h-11 items-center justify-center rounded-full border border-slate-300 bg-white px-5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
          >
            Back to SalonBusinessCPA
          </Link>
        </div>
      </section>
    </main>
  );
}
